/* eslint-disable no-undef */
import { ModalGeneral } from '@salud-front/shared';
import { ModalGeneralComposted } from '../shared/ModalGeneralComposted';
import { AppointmentLocation } from './location/appointmentLocation';
import { BackAndSearchAppointmentActions } from './actions/backAndSearchAppointmentActions';
import { DoctorSelectedToAppoinment } from './actions/doctorSelectedToAppoinment';
import { AssignedDoctorSelector } from './results/assignedDoctorSelector';
import { AffiliateAndSpecialtySelector } from './ui/affiliateAndSpecialtySelector';
import { SelectLocationsList } from './ui/selectLocationList';
import {
  consultaRedV2Service,
  EventDataExtractor,
  ConsultaRedV2StateManager,
  nonComplianceAdapter,
  AnalyticsService,
  AppointmentServices,
  sharepointServices,
} from './services';
import { IngresarAgendarCitaMedicaModel } from '../models/IngresarAgendarCitaMedicaModel';
import { DESKTOP_BREAKPOINT, PERSONAL_DOCTOR_CODES } from '../constants/appointmentConstants';
import { formatDate, getDaysBetweenDates } from '../util/dateUtils';
import {
  getSpecialityName,
  getFilteredSelectedLocations,
  setDataToAppointmentByUser,
  setDataToPerson,
  isDefined,
  hasDoctorAssigned,
} from '../util/appointmentUtils';
import { buildModalTitle, getModalButtonText } from '../util/modalUtils';

export class IndexComponent extends React.Component {
  /**
   * Inicializa el componente con el estado centralizado desde el modelo.
   */
  constructor(props) {
    super(props);
    this.state = { ...IngresarAgendarCitaMedicaModel };
    this._isMounted = false;
    this.activeModal = this.activeModal.bind(this);
    this.handleModalConfirm = this.handleModalConfirm.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getConfigurationFromSharepoint = this.getConfigurationFromSharepoint.bind(this);
    this.getDataInFilterService = this.getDataInFilterService.bind(this);
    this.handleRedirectLiftNonCompliance = this.handleRedirectLiftNonCompliance.bind(this);
    this.handleRedirectCancelAction = this.handleRedirectCancelAction.bind(this);
    this.popUpAdministration = this.popUpAdministration.bind(this);
    this.getEspecialidadesEnPopUp = this.getEspecialidadesEnPopUp.bind(this);
    this.getESedesEnPopUp = this.getESedesEnPopUp.bind(this);
    this.lineBreak = this.lineBreak.bind(this);
    this.textFormatted = this.textFormatted.bind(this);
    this.handlePopUpOnMount = this.handlePopUpOnMount.bind(this);    
    this.processConsultaRed = this.processConsultaRed.bind(this);
    this.sendG4AnalyticsEvent = this.sendG4AnalyticsEvent.bind(this);
  }
  
  /**
   * Ciclo de vida: ejecuta la configuración inicial y autenticación al montar el componente.
   */
  componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      this.getConfigurationFromSharepoint();
      this.isAuthenticated();
      this.popUpAdministration();
    }, 500);
  }

  /**
   * Ciclo de vida: marca el componente como desmontado.
   */
  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Obtiene y aplica la configuración de popups administrativos.
   */
  async popUpAdministration() {
    const cached = sessionStorage.getItem('popUpAdministration');
    let list;
    if (cached) {
      list = JSON.parse(cached);
      this.setState({ popUpAdministration: list });
    } else {
      list = await sharepointServices.getPopupAdministration();
      sessionStorage.setItem('popUpAdministration', JSON.stringify(list));
      this.setState({ popUpAdministration: list });
      if (list[1].Popup === false) {
        this.setState({ popUpUbicacion: true, popUpApointment: true });
      }
    }
    if (this._isMounted) {
      this.handlePopUpOnMount(list[2], false);
    } else {
      this.handlePopUpOnMount(list[2]);
    }
  }

  /**
   * Obtiene la configuración de transacciones desde SharePoint y la guarda en el estado.
   */
  async getConfigurationFromSharepoint() {
    const configurations = await sharepointServices.getConfigurations();
    this.setState({ configurations });
  }

  /**
   * Muestra el popup de especialidades si está habilitado en la configuración.
   */
  async handlePopUpOnMount(item, show = true) {
    if (item && item['Popup'] === true && show) {
      const list = await sharepointServices.getEspecialidadesEnPopup();
      this.setState({ popUpContent: list[0], popUpModal: true });
    }
  }

  /**
   * Busca y muestra la información de una especialidad en el popup.
   */
  async getEspecialidadesEnPopUp(item) {
    const list = await sharepointServices.getEspecialidadesEnPopup();
    const newResult = list.filter((result) => result.Code === item.value);
    this.setState({ popUpContent: newResult[0], popUpModal: true });
    if (newResult.length === 0) {
      this.setState({ popUpUbicacion: true, popUpApointment: true });
    }
  }

  /**
   * Busca y muestra la información de una sede en el popup.
   */
  async getESedesEnPopUp(item) {
    const list = await sharepointServices.getSedesEnPopup();
    list.forEach((result) => {
      if (result.Code === item) {
        this.setState({ popUpContent: result, popUpModal: true });
      }
    });
  }

  /**
   * Verifica si el usuario está autenticado y obtiene su información.
   */
  isAuthenticated() {
    if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
      const authenticatedUser = compTools.obtenerInformacionUsuario();
      this.setState({
        isAuthenticatedBoolean: true,
        userInfo: authenticatedUser,
      });
      this.initService(
        compTools.obtenerInformacionUsuario().LegalID,
        compTools.obtenerInformacionUsuario().TipoIdentificacion,
      );
    }
  }

  /**
   * Consulta y guarda las sedes PBS para el usuario actual.
   */
  async getServiceForPBS(id, type, program) {
    try {
      const data = await AppointmentServices.getPBSBranchCode(id, type, program);
      if (data.ResponseCode === 200) {
        const branchArr = [data.Result];
        localStorage.setItem('SedesCodeAux', branchArr);
        this.setState({ branchSelectedResponse: branchArr, statusRequest: 2 });
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        this.setState({ error: true });
        this.getErrorMessage(
          data.ResponseDetail,
          parseText('sharedResources.Modal.Buttons.Cerrar'),
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.False'),
        );
      } else if (data.ResponseCode === 430) {
        this.setState({ btnCerrarAceptar: 'Aceptar' });
        this.getErrorMessage(
          data.ResponseDetail,
          parseText('sharedResources.Modal.Buttons.Cancelar'),
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Inicializa el acceso a citas médicas y verifica el perfil del usuario.
   */
  async initService(id, type) {
    try {
      const data = await AppointmentServices.checkUserAppointmentsAccess(type, id);
      if (data.ResponseCode === 200) {
        if (data.Result == null) {
          this.getListAffiliates();
        } else {
          if (data.Result.AffiliatedHasAccess) {
            this.getListAffiliates();
            compensar.PBSLocation = data.Result.PBSLocation;
            data.Result.Program === 'PA' && sessionStorage.setItem('Program', true);
            data.Result.Program === 'PC' && this.getServiceForPBS(id, type, data.Result.Program);
            this.setState({ userAppointmentAccess: data.Result });
          } else {
            this.setState({
              error: true,
              ico: true,
              linkBack: true,
              AffiliatedHasAccess: data.Result.AffiliatedHasAccess,
            });
            this.getErrorMessage(
              parseText('Form.ModalMessage.NoPerfil'),
              parseText('sharedResources.Modal.Buttons.Cerrar'),
              parseText('sharedResources.Modal.Bolean.True'),
              parseText('sharedResources.Modal.Bolean.False'),
            );
            compensar.quitarLoading('.selectorPadre');
          }
        }
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        this.setState({ error: true });
        this.getErrorMessage(
          data.ResponseDetail,
          parseText('sharedResources.Modal.Buttons.Cerrar'),
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.False'),
        );
        compensar.quitarLoading('.selectorPadre');
      } else if (data.ResponseCode === 430) {
        this.setState({ btnCerrarAceptar: 'Aceptar' });
        this.getErrorMessage(
          data.ResponseDetail,
          parseText('sharedResources.Modal.Buttons.Cancelar'),
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.selectorPadre');
      }
    } catch (err) {
      compensar.quitarLoading('.selectorPadre');
      this.getCatchMessage();
    }
  }

  /**
   * Obtiene la lista de afiliados asociados al usuario y gestiona el flujo según la cantidad.
   */
  async getListAffiliates() {
    try {
      const data = await AppointmentServices.getAffiliates(
        this.state.userInfo.LegalID,
        this.state.userInfo.TipoIdentificacion,
      );
      if (data.ResponseCode === 200) {
        if (data.Result == null) {
          this.setState({ error: true, ico: true });
          this.getErrorMessage(
            'Señor usuario en este momento no podemos atender tu solicitud, por favor inténtalo más tarde',
            'Cerrar',
            parseText('sharedResources.Modal.Bolean.False'),
            parseText('sharedResources.Modal.Bolean.True'),
          );
        } else {
          if (data.Result.length === 1) {
            this.setState({
              afiliados: data.Result,
              namePlaceholderUser: data.Result[0].FullName,
            });
            this.getSpecialities(this.state.userInfo.LegalID, data.Result);
          } else {
            this.setState({ afiliados: data.Result });
            compensar.quitarLoading('.principal');
          }
        }
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        this.setState({ error: true });
        this.getErrorMessage(
          data.ResponseDetail,
          'Cerrar',
          parseText('sharedResources.Modal.Bolean.False'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else if (data.ResponseCode === 430) {
        this.getErrorMessage(
          data.ResponseDetail,
          'Cancelar',
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      }
    } catch (error) {
      this.getCatchMessage();
      compensar.quitarLoading('.principal');
      console.log('No Funcionó');
    }
  }

  /**
   * Gestiona la selección de especialidad y usuario, y obtiene los servicios disponibles.
   */
  getSpecialities(event, afiliadosResult) {
    const afiliados = afiliadosResult || this.state.afiliados;
    if (afiliados.length === 1) {
      this.setState({
        BirthDate: formatDate(compTools.obtenerInformacionUsuario().FechaNacimiento),
      });
      this.getDataInFilterService(this.state.userInfo.TipoIdentificacion, this.state.userInfo.LegalID);
    } else if (afiliados.length > 1) {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        this.setState({
          namePlaceholderUser: event.FullNameDrop,
          BirthDate: moment(event.BirthDate).format('YYYY-MM-DD'),
          selectedUserTypeID: event.userType,
          selectedUserId: event.userId,
          noPlacerholderUser: true,
        });
        this.getDataInFilterService(event.userType, event.userId);
      } else {
        this.setState({
          BirthDate: afiliadosResult[event.target.value].BirthDate,
        });
        this.getDataInFilterService(
          afiliadosResult[event.target.value].UserTypeId,
          afiliadosResult[event.target.value].UserId,
        );
      }

      this.setState({
        dateseted: false,
        viewDates: false,
        sedesSeted: false,
        responseContent: false,
        specialityValueSelected: null,
        checkedDoctorInit: true,
      });
    }
  }

  /**
   * Retorna el mensaje para usuarios PBS sin sede asignada.
   */
  setMessagePBSLocation() {
    return (
      <p>
        {parseText('Form.ModalMessage.UserWithoutDefaultAppointmentLocationMessage') + ' '}
        <a
          rel="noreferrer"
          target={parseText('Form.ModalMessage.UserWithoutDefaultAppointmentSelf') ? '_self' : '_blank'}
          href={parseText('Form.ModalMessage.UserWithoutDefaultAppointmentUrl')}
        >
          {parseText('Form.ModalMessage.UserWithoutDefaultAppointmentButtonName')}
        </a>
      </p>
    );
  }

  /**
   * Consulta el acceso a citas médicas y gestiona el flujo según el tipo de afiliación.
   */
  async getDataInFilterService(type, id) {
    compensar.mostrarLoading('.principal');
    try {
      const data = await AppointmentServices.checkUserAppointmentsAccess(type, id);
      if (data.ResponseCode === 200) {
        let groupAssing;
        let Programa;
        if (data.Result.PAAffiliation === true) {
          groupAssing = 'PA';
          Programa = data.Result.Program;
        } else if (data.Result.PCEAffiliation === true) {
          groupAssing = 'PC';
          Programa = data.Result.Program;
        } else {
          groupAssing = 'PBS';
          Programa = data.Result.Program;
          if (data.Result.Program === 'PC') this.getServiceForPBS(id, type, data.Result.Program);
          this.setState({ groupProgram: true });
        }

        !data.Result.PAAffiliation && data.Result.PCEAffiliation
          ? this.setState({ isConditional: true })
          : this.setState({ isConditional: false });

        if (groupAssing === 'PBS' && groupAssing !== 'PC' && groupAssing !== 'PA') {
          var userTypeId = 0;
          var userId = 0;
          if (this.state.afiliados.length === 1) {
            userTypeId = this.state.userInfo.TipoIdentificacion;
            userId = this.state.userInfo.LegalID;
          } else {
            userTypeId = type;
            userId = id;
          }
          if (
            data.Result.PBSLocation === null ||
            data.Result.PBSLocation === undefined ||
            data.Result.PBSLocation === ''
          ) {
            compensar.quitarLoading('.principal');
            this.getInfoRedirectModal(
              this.setMessagePBSLocation(),
              '',
              parseText('Form.ModalMessage.UserWithoutDefaultAppointmentButtonTxt'),
              '',
            );
          } else {
            this.checkExternalAppointmentPlace(userId, userTypeId, Programa, groupAssing);
          }
        } else {
          if (this.state.afiliados.length === 1) {
            this.setServiceState(
              this.state.userInfo.TipoIdentificacion,
              this.state.userInfo.LegalID,
              groupAssing,
              1,
              Programa,
            );
          } else {
            this.setServiceState(type, id, groupAssing, 1, Programa);
          }
          compensar.quitarLoading('.principal');
        }
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        this.setState({ error: true });
        this.getErrorMessage(
          data.ResponseDetail,
          'Cerrar',
          parseText('sharedResources.Modal.Bolean.False'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else if (data.ResponseCode === 430) {
        this.getErrorMessage(
          data.ResponseDetail,
          'Cancelar',
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      }
    } catch (error) {
      this.getCatchMessage();
      compensar.quitarLoading('.principal');
    }
  }

  /**
   * Verifica si el usuario tiene una sede externa asignada y gestiona el flujo.
   */
  async checkExternalAppointmentPlace(userId, userTypeId, program, groupAssing) {
    compensar.mostrarLoading('.principal');
    try {
      const data = await AppointmentServices.checkExternalBranch(userId, userTypeId, program);
      if (data.ResponseCode === 430) {
        this.getInfoMessage(data.ResponseDetail, '', 'Cerrar');
      } else if (data.ResponseCode === 450 || data.ResponseCode === 500) {
        this.setState({ error: true });
        this.getErrorMessage(
          data.ResponseDetail,
          'Cerrar',
          parseText('sharedResources.Modal.Bolean.False'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else {
        this.setServiceState(userTypeId, userId, groupAssing, 1, program);
        compensar.quitarLoading('.principal');
      }
    } catch (error) {
      compensar.quitarLoading('.principal');
    }
  }

  /**
   * Actualiza el estado y obtiene las especialidades disponibles según el grupo y resultado.
   */
  setServiceState(typeId, userId, group, res, pro) {
    if (res === 1) {
      const specialistiesByUser = {
        userTypeId: typeId,
        userId: userId,
        program: pro,
      };
      this.setState({
        userTypeId: typeId,
        userTypeIdentify: group,
        enableDropDown: true,
        afiliateSelected: userId,
        dataToSubmitAppoimentGroup: pro,
        noPlacerholderSpec: false,
        validationDataPromotion: false,
      });
      this.getSpecialtiesValidate(specialistiesByUser);
    } else {
      this.setState({
        specialitySelected: userId,
      });
    }
  }

  /**
   * Consulta las especialidades médicas permitidas para el usuario y actualiza el estado.
   */
  async getSpecialtiesValidate(payload) {
    try {
      const data = await AppointmentServices.getSpecialties(payload);
      const result = data.GetAllowedScheduleMedicalServicesAPIResult;
      if (result.ResponseCode === 200 && result.Result.length !== 0) {
        this.setState({ especialidades: result.Result });
      } else if (result.ResponseCode === 500 || result.ResponseCode === 450) {
        this.setState({ error: true });
        this.getErrorMessage(
          result.ResponseDetail,
          'Cerrar',
          parseText('sharedResources.Modal.Bolean.False'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else if (result.ResponseCode === 430) {
        this.getErrorMessage(
          result.ResponseDetail,
          'Cancelar',
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else if (result.ResponseCode === 200 && result.Result.length === 0) {
        this.setState({ nullResponseSpec: true, enableDropDown: false });
      } else {
        this.getErrorMessage(
          result.ResponseDetail,
          'Cancelar',
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      }
    } catch (error) {
      this.getCatchMessage();
      compensar.quitarLoading('.principal');
      console.log('Error', error);
    }
  }

  isDefined(data) {
    return isDefined(data);
  }

  /**
   * Retorna el nombre de la especialidad seleccionada.
   * Delega en la función utilitaria del módulo de utils.
   */
  getSpecialityName() {
    return getSpecialityName(this.state);
  }

  /**
   * Obtiene las sedes seleccionadas por el usuario para la cita médica.
   * Delega en la función utilitaria del módulo de utils.
   */
  getFilteredSelectedLocations() {
    return getFilteredSelectedLocations();
  }

  /**
   * Verifica si el médico asignado está disponible y actualiza el estado si corresponde.
   * Usa la función pura hasDoctorAssigned del módulo de utils.
   */
  checkInit(data) {
    const result = hasDoctorAssigned(data, this.state.isRedService);
    if (result) this.checkInitTrue();
    return result;
  }

  /**
   * Oculta las sedes y habilita el botón de completar si la fecha está seteada.
   */
  checkInitTrue() {
    this.setState({ hideSedes: true, sedesSeted: true, statusRequest: 1 });
    this.state.dateseted
      ? this.setState({ enableButtonComplete: false })
      : this.setState({ enableButtonComplete: true });

    return true;
  }

  /**
   * Consulta el servicio V2 de direccionamiento para obtener médico y sedes según la especialidad.
   * Refactorizado para usar servicios centralizados con responsabilidad única.
   */
  processConsultaRed = async (event) => {
    try {
      // 1. Mostrar popup si está habilitado
      this.handlePopupIfEnabled(event);

      // 2. Extraer datos del evento (Desktop vs Mobile) y resolver CUPS antes del direccionamiento.
      const eventData = EventDataExtractor.extractAllEventData(event);
      const resolvedEventData = await this.getCupsControl(eventData);

      // 3. Actualizar estado inicial
      this.setState(ConsultaRedV2StateManager.buildInitialState(resolvedEventData));

      // 4. Mostrar loading
      compensar.mostrarLoading('.principal');

      // 5. Consultar servicio V2 con fallback automático a V1
      const result = await consultaRedV2Service.consultWithFallback({
        userTypeId: this.state.userTypeId,
        userId: this.state.afiliateSelected,
        serviceCode: resolvedEventData.specialtyValue,
        agrupador: resolvedEventData.agrupador,
        specialtySelected: resolvedEventData.specialtyValue,
        dataNameSelected: resolvedEventData.promotionData.name,
        isPromotionAndPrevention: resolvedEventData.promotionData.promotion,
      });

      // 6. Procesar resultado
      if (result.success) {
        await this.handleConsultaRedV2Success(result, resolvedEventData);
      } else if (result.fallbackToV1) {
        console.log('⚠️ Fallback a V1 activado');
        this.processRedMedic(eventData, resolvedEventData.specialtyValue);
      } else {
        this.handleConsultaRedV2Error(result);
      }
    } catch (error) {
      console.error('❌ Error en processConsultaRed:', error);
      this.setState({ isRedService: false });
      const eventData = EventDataExtractor.extractAllEventData(event);
      const resolvedEventData = await this.getCupsControl(eventData);
      this.processRedMedic(eventData, resolvedEventData.specialtyValue);
    } finally {
      compensar.quitarLoading('.principal');
    }
  };

  /**
   * Muestra el popup de especialidades si está habilitado en la configuración
   */
  handlePopupIfEnabled = (event) => {
    if (
      this.state.popUpAdministration &&
      this.state.popUpAdministration[1] &&
      this.state.popUpAdministration[1].Popup === true
    ) {
      this.getEspecialidadesEnPopUp(event);
    }
  };

  /**
   * Procesa la respuesta exitosa de ConsultaRedV2
   */
  handleConsultaRedV2Success = async (result, eventData) => {
    const { data, hasPersonalDoctor, oneBranche, selectedBranch } = result;
    const { specialtyValue, promotionData } = eventData;

    // Actualizar estado con datos de éxito
    // Se pasan oneBranche y selectedBranch desde el root de result (no están en data)
    this.setState(ConsultaRedV2StateManager.buildSuccessState(
      { ...data, oneBranche, selectedBranch },
      this.state.groupProgram,
    ));

    // Guardar info de contacto afiliado si existe
    if (data.affiliatedContactInfo) {
      this.setState({ affiliatedContactInfoRedService: data.affiliatedContactInfo });
    }

    // Manejar caso de citas asignadas
    if (data.hasAssignedAppointments) {
      this.setState(ConsultaRedV2StateManager.buildAssignedAppointmentState(specialtyValue));
      this.getErrorMessage(
        `Señor usuario, actualmente ya posee una cita médica asignada para el servicio ${toolsTransacciones.toCapitalize(promotionData.name)} que ha seleccionado`,
        'Próxima Cita',
        parseText('sharedResources.Modal.Bolean.True'),
        parseText('sharedResources.Modal.Bolean.True'),
      );
    }

    // Manejar incumplimientos si existen
    if (data.hasNonCompliances && data.nonCompliances.length > 0) {
      await this.handleNonCompliances(data.nonCompliances, promotionData.name);
    }

    // Enviar evento a analytics
    this.sendAnalyticsEvent(specialtyValue);
  };

  /**
   * Procesa incumplimientos (pedagógicos y económicos)
   */
  handleNonCompliances = async (nonCompliances, serviceNameSelected) => {
    const ncData = nonComplianceAdapter.getPedagogicNonCompliances(
      nonCompliances,
      this.getDaysBetweenDates
    );

    const economicNC = nonComplianceAdapter.getEconomicNonCompliances(
      nonCompliances,
      this.getDaysBetweenDates
    );

    const ncType = nonComplianceAdapter.determineNonComplianceType(ncData, economicNC);

    // Construir información para sessionStorage
    const ncInfo = ConsultaRedV2StateManager.buildNonComplianceInfo({
      nonComplianceData: { pedagogic: ncData, economic: economicNC },
      affiliatesLength: this.state.afiliados.length,
      state: this.state,
      serviceCode: this.state.serviceCode,
      namePlaceholderSpec: this.state.namePlaceholderSpec,
    });

    window.sessionStorage.setItem('nonComplianceInfo', JSON.stringify(ncInfo));

    // Mostrar modal según tipo de incumplimiento
    if (ncType === 'both') {
      this.showBothNonCompliancesModal(ncData, economicNC);
    } else if (ncType === 'pedagogic') {
      this.showPedagogicNonComplianceModal(ncData, economicNC);
    } else if (ncType === 'economic') {
      this.showEconomicNonComplianceModal(economicNC);
    }

    // Procesar fechas
    this.getDate(false);
  };

  /**
   * Muestra modal para ambos tipos de incumplimientos
   */
  showBothNonCompliancesModal = (pedagogicNC, economicNC) => {
    const messageTitle = parseText('Form.ModalMessage.NonCompliancesModalTitle');
    const pedagogicCups = nonComplianceAdapter.getCupsDescriptions(pedagogicNC);
    const economicCups = nonComplianceAdapter.getCupsDescriptions(economicNC);

    const messageBody = toolsTransacciones.formatString(
      parseText('Form.ModalMessage.BothNonCompliances'),
      economicCups,
      pedagogicCups,
    );

    const redirectURL = _spPageContextInfo.siteAbsoluteUrl + parseText('Form.General.LiftNonComplianceURL');
    const mainButtonText = parseText('Form.ModalMessage.LiftPedagogicNonComplianceModalMainButtonText');
    const altButtonText = parseText('Form.ModalMessage.LiftPedagogicNonComplianceModalAltButtonText');
    const thirdButtonText = parseText('Form.ModalMessage.ViewAppointmentLocations');

    this.activeCompositeModal(
      messageTitle,
      messageBody,
      mainButtonText,
      altButtonText,
      thirdButtonText,
      redirectURL,
    );
  };

  /**
   * Muestra modal para incumplimientos pedagógicos
   */
  showPedagogicNonComplianceModal = (pedagogicNC, economicNC) => {
    const pedagogicCups = nonComplianceAdapter.getCupsDescriptions(pedagogicNC);

    const messageTitle = toolsTransacciones.formatString(
      parseText('Form.ModalMessage.NonComplianceModalTitle'),
      'Pedagogico',
    );

    const messageBody = toolsTransacciones.formatString(
      parseText('Form.ModalMessage.PedagogicNonComplianceModalBody'),
      pedagogicCups,
    );

    const redirectURL = _spPageContextInfo.siteAbsoluteUrl + parseText('Form.General.LiftNonComplianceURL');
    const mainButtonText = parseText('Form.ModalMessage.LiftPedagogicNonComplianceModalMainButtonText');
    let altButtonText = parseText('Form.ModalMessage.LiftPedagogicNonComplianceModalAltButtonText');

    // Si también hay incumplimientos económicos
    if (economicNC && economicNC.length > 0) {
      const economicCups = nonComplianceAdapter.getCupsDescriptions(economicNC);
      const economicTitle = toolsTransacciones.formatString(
        parseText('Form.ModalMessage.NonComplianceModalTitle'),
        'Economico',
      );

      const economicBody = toolsTransacciones.formatString(
        parseText('Form.ModalMessage.EconomicNonComplianceModalBody'),
        economicCups,
      );

      const economicRedirectURL = parseText('Form.ModalMessage.EconomicNonComplianceRedirectUrl');
      const economicMainButtonText = parseText('Form.ModalMessage.LiftEconomicNonComplianceModalMainButtonText');
      const economicAltButtonText = parseText('Form.ModalMessage.LiftEconomicNonComplianceModalAltButtonText');

      this.getRedirectModal(economicBody, economicTitle, economicMainButtonText, economicAltButtonText, economicRedirectURL);
    }

    this.getRedirectModal(messageBody, messageTitle, mainButtonText, altButtonText, redirectURL);
  };

  /**
   * Muestra modal para incumplimientos económicos
   */
  showEconomicNonComplianceModal = (economicNC) => {
    const economicCups = nonComplianceAdapter.getCupsDescriptions(economicNC);

    const messageTitle = toolsTransacciones.formatString(
      parseText('Form.ModalMessage.NonComplianceModalTitle'),
      'Economico',
    );

    const messageBody = toolsTransacciones.formatString(
      parseText('Form.ModalMessage.EconomicNonComplianceModalBody'),
      economicCups,
    );

    const redirectURL = parseText('Form.ModalMessage.EconomicNonComplianceRedirectUrl');
    const mainButtonText = parseText('Form.ModalMessage.LiftEconomicNonComplianceModalMainButtonText');
    const altButtonText = parseText('Form.ModalMessage.LiftEconomicNonComplianceModalAltButtonText');

    this.getRedirectModal(messageBody, messageTitle, mainButtonText, altButtonText, redirectURL);
  };

  /**
   * Maneja errores de ConsultaRedV2
   */
  handleConsultaRedV2Error = (result) => {
    this.setState(ConsultaRedV2StateManager.buildErrorState(result));
    this.getErrorMessage(
      result.errorMessage || 'Error procesando la solicitud',
      parseText('sharedResources.Modal.Buttons.Cerrar'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
    );
  };

  /**
   * Envía evento a Google Analytics
   */
  sendAnalyticsEvent = (specialtyValue) => {
    const userInfo = compTools.obtenerInformacionUsuario();
    const specialtyName = this.getSpecialityName();
    AnalyticsService.trackAppointmentScheduling(userInfo, specialtyName);
  };

  /**
   * Consulta el servicio antiguo (V1) para obtener médico y sedes en caso de contingencia.
   */
  processRedMedic = async (eventData, cupsServiceCode) => {
    // V1 siempre direcciona con el CUPS original; CupsControl solo aplica a disponibilidad.

    // 1. Establecer estado inicial
    this.setState(this.buildV1InitialState(eventData, cupsServiceCode));

    // 2. Mostrar loading
    compensar.mostrarLoading('.principal');

    // 3. Consultar servicio V1
    try {
      const originalServiceCode = String(eventData.specialtyValue || '');
      const personalDoctorPayload = this.buildV1RequestPayload(eventData, eventData.agrupador == 1);
      let data = await AppointmentServices.getAppointmentsV1(personalDoctorPayload);
      let personalDoctor = false;
      let doctorAssigned = false;
      const firstResponseServiceCode = String(data?.Result?.ServiceCode || '');
      const hasMatchingPersonalDoctor =
        data?.ResponseCode === 200 &&
        firstResponseServiceCode === originalServiceCode &&
        data?.Result?.UserHasAssignedPersonalDoctor === true &&
        hasDoctorAssigned(data, false);

      if (hasMatchingPersonalDoctor) {
        personalDoctor = true;
        doctorAssigned = true;
      } else if (data?.ResponseCode === 200 && firstResponseServiceCode !== originalServiceCode) {
        const treatingDoctorPayload = this.buildV1RequestPayload(eventData, false);
        data = await AppointmentServices.getAppointmentsV1(treatingDoctorPayload);
        doctorAssigned =
          data?.ResponseCode === 200 &&
          data?.Result?.UserHasAssignedTreatingDoctor === true &&
          hasDoctorAssigned(data, false);
      }

      if (data?.ResponseCode === 200 && !doctorAssigned) {
        data = {
          ...data,
          Result: {
            ...data.Result,
            AssignedDoctor: null,
          },
        };
      }

      if (doctorAssigned) this.checkInitTrue();
      this.setState({ isRedService: false });
      await this.handleV1Response(data, eventData, doctorAssigned, personalDoctor, cupsServiceCode);
    } catch (error) {
      const messageBody =
        'Señor usuario, en el momento no me es posible procesar tu solicitud. Por favor intenta mas tarde.';
      const redirectURL = _spPageContextInfo.siteAbsoluteUrl + '/transacciones/servicios-m%C3%A9dicos/citas-medicas/';
      this.getRedirectModal(messageBody, '', '', 'Cerrar', redirectURL);
      compensar.quitarLoading('.principal');
      console.log('No Funciona', error);
    }
  };

  /**
   * Construye el estado inicial para el flujo V1 a partir de los datos del evento.
   */
  buildV1InitialState = (eventData, cupsServiceCode) => {
    const { specialtyValue, promotionData, validationDataPromotion } = eventData;
    return {
      oneBranche: false,
      showEspecialidadesPopup: true,
      dateseted: false,
      viewDates: false,
      sedesSeted: this.state.groupProgram ? true : false,
      cupsEvent: eventData,
      personalDoctor: false,
      hideSedes: true,
      namePlaceholderSpec: promotionData.nameService,
      noPlacerholderSpec: true,
      serviceCode: cupsServiceCode,
      specialitySelected: cupsServiceCode,
      validationDataPromotion: validationDataPromotion,
      isPromotionAndPrevention: promotionData.promotion,
      infoIsPromotionActive: EventDataExtractor.buildDisplayInfo(promotionData),
    };
  };

  /**
   * Construye el payload para la petición al servicio V1.
   */
  buildV1RequestPayload = (eventData, isPersonalDoctor) => {
    const { specialtyValue, promotionData } = eventData;
    return {
      userTypeId: this.state.userTypeId,
      userId: this.state.afiliateSelected,
      serviceCode: specialtyValue,
      isPromotionAndPrevention: !specialtyValue ? 'true' : promotionData.promotion,
      isPersonalDoctor: isPersonalDoctor ? 'true' : 'false',
      AplicativoAgenda: 0,
    };
  };

  /**
   * Maneja la respuesta del servicio V1 según el código de respuesta.
   */
  handleV1Response = async (data, eventData, doctorAssigned, personalDoctor, cupsServiceCode) => {
    if (data.ResponseCode === 200 && data.Result) {
      await this.handleV1SuccessResponse(data, eventData, doctorAssigned, personalDoctor, cupsServiceCode);
      compensar.quitarLoading('.principal');
    } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
      this.setState({ error: true });
      this.getErrorMessage(
        'Señor usuario, en el momento no me es posible procesar tu solicitud. Por favor intenta mas tarde.',
        'Cerrar',
        parseText('sharedResources.Modal.Bolean.False'),
        parseText('sharedResources.Modal.Bolean.True'),
      );
      compensar.quitarLoading('.principal');
    } else if (data.ResponseCode === 430) {
      this.getErrorMessage(
        'Señor usuario, en el momento no me es posible procesar tu solicitud. Por favor intenta mas tarde.',
        'Cancelar',
        parseText('sharedResources.Modal.Bolean.True'),
        parseText('sharedResources.Modal.Bolean.True'),
      );
      compensar.quitarLoading('.principal');
    } else {
      compensar.quitarLoading('.principal');
    }
  };

  /**
   * Procesa la respuesta exitosa (200) del servicio V1.
   */
  handleV1SuccessResponse = async (data, eventData, doctorAssigned, personalDoctor, cupsServiceCode) => {
    const { specialtyValue, promotionData } = eventData;

    this.sendAnalyticsEvent(specialtyValue);

    if (data.Result.UserHasAssignedAppointments) {
      this.setState({
        sinCitas: true,
        enableButtonComplete: true,
        viewDates: true,
        specialtySelected: cupsServiceCode,
        serviceCode: cupsServiceCode,
        checkedDoctorInit: doctorAssigned,
        personalDoctor,
      });
      this.getErrorMessage(
        'Señor usuario, actualmente ya posee una cita médica asignada para el servicio ' +
          toolsTransacciones.toCapitalize(promotionData.name) +
          ' que ha seleccionado',
        'Próxima Cita',
        parseText('sharedResources.Modal.Bolean.True'),
        parseText('sharedResources.Modal.Bolean.True'),
      );
    } else {
      this.setState({
        viewDates: true,
        responseContent: true,
        hideSedes: doctorAssigned,
        enableButtonComplete: true,
        checkedDoctorInit: doctorAssigned,
        personalDoctor,
        medicalAvailable: data.Result,
        specialtySelected: cupsServiceCode,
        serviceCode: cupsServiceCode,
        dataLayerMedicalLocations: this.getFilteredSelectedLocations(),
      });

    }

    if (data.Result.UserHasNonCompliances && data.Result.NonCompliances) {
      await this.handleNonCompliances(data.Result.NonCompliances, promotionData.name);
    }
  };

  /**
   * Construye el objeto de datos para buscar disponibilidad de citas por usuario.
   * Delega en la función utilitaria del módulo de utils.
   */
  setDataToAppointmentByUser() {
    return setDataToAppointmentByUser(this.state);
  }

  /**
   * Construye el objeto de datos de la persona para almacenar en localStorage.
   * Delega en la función utilitaria del módulo de utils.
   */
  setDataToPerson() {
    return setDataToPerson(this.state);
  }

  /**
   * Almacena la información de la solicitud de cita médica en localStorage y redirige al usuario.
   */
  setInfoToStorage(data) {
    var dataToStorage = data;
    dataToStorage.peticion = this.setDataToAppointmentByUser();
    dataToStorage.person = this.setDataToPerson();
    if (this.state.isRedService && dataToStorage.person && dataToStorage.person.innerPerson) {
      dataToStorage.person.innerPerson.affiliatedContactInfo = this.state.affiliatedContactInfoRedService;
    }
    dataToStorage.flow = 'Agendamiento cita';
    compTools.infoSolicitudAfiliacion.setEnLocal(dataToStorage);
    window.location.href = _spPageContextInfo.siteAbsoluteUrl + parseText('Form.UrlBuscarCitas');
    compensar.quitarLoading('.principal');
  }

  /**
   * Consulta la disponibilidad de citas médicas para el usuario y especialidad seleccionada.
   */
  async searchAppointmentByUser() {
    compensar.mostrarLoading('.principal');
    try {
      const data = await AppointmentServices.searchAppointments(this.setDataToAppointmentByUser());
      const userInfo = compTools.obtenerInformacionUsuario();
      AnalyticsService.trackAppointmentSearch(userInfo, this.getSpecialityName(), this.getFilteredSelectedLocations());
      if (data.ResponseCode === 200 && data.Result.Appointments === null) {
        this.setInfoToStorage(data.Result);
      } else if (data.ResponseCode === 200 && data.Result.Appointments.length === 0) {
        this.setInfoToStorage(data.Result);
      } else if (data.ResponseCode === 200 && data.Result.Appointments.length > 0) {
        this.setInfoToStorage(data.Result);
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        this.setState({ error: true });
        this.getErrorMessage(
          data.ResponseDetail,
          'Cerrar',
          parseText('sharedResources.Modal.Bolean.False'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else if (data.ResponseCode === 430) {
        this.getErrorMessage(
          data.ResponseDetail,
          'Cancelar',
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      } else {
        this.getErrorMessage(
          data.ResponseDetail,
          'Cancelar',
          parseText('sharedResources.Modal.Bolean.True'),
          parseText('sharedResources.Modal.Bolean.True'),
        );
        compensar.quitarLoading('.principal');
      }
    } catch (error) {
      this.getCatchMessage();
      compensar.quitarLoading('.principal');
      console.log('No Funciona', error);
    }
  }

  /**
   * Gestiona la selección del médico para la cita médica y actualiza el estado.
   */
  doctorSelectedToAppoinment(event) {
    if (event.target.checked) {
      // Doctor seleccionado: siempre query por médico (statusRequest:1), independiente de si hay fecha
      this.setState({ hideSedes: true, sedesSeted: true, statusRequest: 1 });
      this.state.dateseted
        ? this.setState({ enableButtonComplete: false })
        : this.setState({ enableButtonComplete: true });
    } else {
      const isPBS = this.state.userTypeIdentify === 'PBS';
      const hasSingleSelectedBranch = this.state.oneBranche && !!this.state.oneBrancheSelected?.Code;
      // Doctor deseleccionado: siempre query por sedes (statusRequest:2), independiente de si hay fecha
      this.setState({
        hideSedes: isPBS ? true : false,
        sedesSeted: isPBS ? true : hasSingleSelectedBranch,
        statusRequest: 2,
      });
      this.state.dateseted && (isPBS || hasSingleSelectedBranch)
        ? this.setState({ enableButtonComplete: false })
        : this.setState({ enableButtonComplete: true });
    }
  }

  /**
   * Renderiza el componente adecuado según el perfil del usuario (PBS, PA, etc.).
   */
  renderComponentByUserProfile() {
    var render;
    if (this.state.userTypeIdentify === 'PBS') {
      render = this.viewToUserTypePbs();
    } else if (this.state.userTypeIdentify === 'PC') {
      render = this.viewToUserTypePceAppoinmentLocation();
    } else {
      render = this.viewToUserTypePA();
    }
    return render;
  }

  /**
   * Procesa y actualiza la fecha seleccionada para la cita médica.
   */
  getDate(date) {
    if (date) {
      const userInfo = compTools.obtenerInformacionUsuario();
      AnalyticsService.trackDateSelection(userInfo, this.getSpecialityName(), this.getFilteredSelectedLocations());
      this.setState({ dateseted: true, dateSelected: moment(date).format('YYYYMMDD') });

      if (
        ((this.state.itemSedes && this.state.itemSedes.length > 0) || this.state.hideSedes) &&
        this.state.sedesSeted
      ) {
        this.setState({ enableButtonComplete: false });
      } else if (this.state.itemSedes === undefined) {
        this.setState({ enableButtonComplete: true });
      }

      if (!this.state.hideSedes && this.state.sedesSeted) {
        this.setState({ enableButtonComplete: false });
      }
    }
  }

  /**
   * Actualiza el estado con las sedes seleccionadas por el usuario.
   */
  itemsChekeados(items) {
    this.setState({ itemSedes: items });

    if (items.length === 0) {
      this.setState({ sedesSeted: false, enableButtonComplete: true });
      return;
    }

    if (this.state.popUpAdministration[0] !== undefined && this.state.popUpAdministration[0].Popup !== undefined) {
      if (this.state.popUpAdministration[0].Popup === true) {
        if (items.length > 0) this.getESedesEnPopUp(items[items.length - 1].itemId);
      }
    }

    if (items.length > 0) {
      this.setState({ sedesSeted: true, branchSelectedResponse: items, statusRequest: 2 });
      this.state.dateseted
        ? this.setState({ enableButtonComplete: false })
        : this.setState({ enableButtonComplete: true });
    } else {
      this.setState({ sedesSeted: false });
    }
  }

  /**
   * Renderiza la vista para usuarios tipo PBS.
   */
  viewToUserTypePbs() {
    return (
      <div>
        <AssignedDoctorSelector
          MedicalAvailable={this.state.medicalAvailable}
          personalDoctor={this.state.personalDoctor}
          Icon={this.state.iconoNotFound}
          checkedDoctor={this.state.checkedDoctorInit}
          disabledCheck={this.state.serviceCode}
          Message={compensar.personalDoctor ? this.state.notFoundMessageForPersonalDoctor : this.state.pbsMessage}
          Target={this.state.targetNotFound}
          DoctorSelected={this.doctorSelectedToAppoinment.bind(this)}
          TargetURL={parseText('Form.General.AssignPersonalDoctorUrl')}
          ShowLink={true}
        />
        {this.state.viewDates ? <DoctorSelectedToAppoinment getDateFromPicker={this.getDate.bind(this)} /> : null}
      </div>
    );
  }

  /**
   * Renderiza la vista para usuarios tipo PA.
   */
  viewToUserTypePA() {
    return (
      <div>
        <AssignedDoctorSelector
          MedicalAvailable={this.state.medicalAvailable}
          personalDoctor={this.state.personalDoctor}
          Icon={this.state.iconoNotFound}
          checkedDoctor={this.state.checkedDoctorInit}
          disabledCheck={this.state.serviceCode}
          Message={compensar.personalDoctor ? this.state.notFoundMessageForPersonalDoctor : this.state.paMessage}
          Target={this.state.targetNotFound}
          DoctorSelected={this.doctorSelectedToAppoinment.bind(this)}
          TargetURL={parseText('Form.General.AssignPersonalDoctorUrl')}
          ShowLink={true}
        />
        {!this.state.hideSedes ? (
          <SelectLocationsList
            itemChecked={this.itemsChekeados.bind(this)}
            AppointmentLocations={
              Array.isArray(this.state.medicalAvailable.AvailableBranches)
                ? this.state.medicalAvailable.AvailableBranches
                : []
            }
          />
        ) : null}

        {this.state.viewDates ? <DoctorSelectedToAppoinment getDateFromPicker={this.getDate.bind(this)} /> : null}
      </div>
    );
  }

  /**
   * Renderiza la vista de selección de sedes para usuarios PCE.
   */
  viewToUserTypePceAppoinmentLocation() {
    return (
      <div>
        <AssignedDoctorSelector
          MedicalAvailable={this.state.medicalAvailable}
          personalDoctor={this.state.personalDoctor}
          Icon={this.state.iconoNotFound}
          checkedDoctor={this.state.checkedDoctorInit}
          disabledCheck={this.state.serviceCode}
          Message={
            compensar.personalDoctor
              ? this.state.notFoundMessageForPersonalDoctor
              : this.state.notFoundPceMessageForSpecialty
          }
          Target={this.state.targetNotFound}
          DoctorSelected={this.doctorSelectedToAppoinment.bind(this)}
          TargetURL={parseText('Form.General.AssignPersonalDoctorUrl')}
          ShowLink={true}
        />
        {!this.state.hideSedes ? (
          <AppointmentLocation
            baseBranches={
              this.state.baseBranches.length > 0 ? this.state.baseBranches : this.state.newBranchesRedService
            }
            oneBranche={this.state.oneBranche}
            itemChecked={this.itemsChekeados.bind(this)}
            AppointmentLocations={
              Array.isArray(this.state.medicalAvailable.AvailableBranches)
                ? this.state.medicalAvailable.AvailableBranches
                : []
            }
          />
        ) : null}

        {this.state.viewDates ? <DoctorSelectedToAppoinment getDateFromPicker={this.getDate.bind(this)} /> : null}
      </div>
    );
  }

  /**
   * Abre el modal informativo con recomendaciones para la cita.
   */
  openModalInformative() {
    this.setState({ openModalInformativo: true });
    return this.activeModal(
      'RECOMENDACIONES PARA ESTA CITA',
      'Cerrar',
      this.state.infoIsPromotionActive.description,
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
    );
  }

  /**
   * Activa y muestra el modal general con los parámetros indicados.
   */
  activeModal(title, btnCerrarCancelar, message, icono, colorIco, noX, noAceptar, noCancelar) {
    this.setState({
      titleModal: title,
      btnCerrarCancelar: btnCerrarCancelar,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
    });
    this.refs.activeModal.handleShow();
  }

  /**
   * Muestra el modal de error genérico del sistema.
   */
  getCatchMessage() {
    return this.activeModal(
      parseText('sharedResources.Modal.Title.Error'),
      'Cerrar',
      parseText('sharedResources.Modal.Lead.ErrorSistema'),
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
      parseText('sharedResources.Modal.Bolean.True'),
    );
  }

  /**
   * Muestra un modal informativo personalizado.
   */
  getInfoMessage(messageBody, messageTitle, mainButtonText) {
    return this.activeModal(
      messageTitle,
      mainButtonText,
      messageBody,
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
    );
  }

  /**
   * Activa y muestra el modal de redirección con los parámetros indicados.
   */
  activeRedirectModal(title, message, icono, colorIco, noX, noAceptar, noCancelar, mainButtonText, altButtonText, url) {
    this.setState({
      titleModal: title,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
      redirectModalAltButtonText: altButtonText,
      redirectModalMainButtonText: mainButtonText,
      urltoRedirect: url,
    });
    this.refs.redirectModalIncumplimientos.handleShow();
  }

  /**
   * Muestra el modal de redirección con información y botones personalizados.
   */
  getRedirectModal(message, title, mainButtonText, altButtonText, url) {
    return this.activeRedirectModal(
      title,
      message,
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
      parseText('sharedResources.Modal.Bolean.True'),
      mainButtonText,
      altButtonText,
      url,
    );
  }

  /**
   * Muestra el modal de redirección informativo con un solo botón.
   */
  getInfoRedirectModal(message, title, mainButtonText, url) {
    return this.activeRedirectModal(
      title,
      message,
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
      parseText('sharedResources.Modal.Bolean.False'),
      mainButtonText,
      '',
      url,
    );
  }

  /**
   * Retorna el título adecuado para el modal según el estado actual.
   * Delega en la función utilitaria buildModalTitle.
   */
  setTitle() {
    return buildModalTitle(this.state.sinCitas, this.state.AffiliatedHasAccess);
  }

  /**
   * Muestra el modal informativo cuando no hay citas disponibles.
   */
  getInformative() {
    return this.activeModal(
      parseText('Form.General.ErrorSistema'),
      'Enviar solicitud',
      this.state.userTypeIdentify !== 'PBS' || this.state.userTypeIdentify !== 'PC'
        ? parseText('Form.ModalMessage.WithoutAppoinmentEAAB')
        : parseText('Form.ModalMessage.WithoutAppoinmentGeneral'),
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.True'),
      parseText('sharedResources.Modal.Bolean.True'),
      parseText('sharedResources.Modal.Bolean.True'),
    );
  }

  /**
   * Muestra el modal de error con los botones indicados.
   */
  getErrorMessage(error, btnCerrarCancelar, btnAceptar, btnCerrar) {
    return this.activeModal(
      this.setTitle(),
      btnCerrarCancelar,
      error,
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      btnAceptar,
      btnCerrar,
    );
  }

  /**
   * Cierra el modal y deshabilita el botón correspondiente.
   */
  close() {
    this.setState({ disabledbtn: true });
    this.handleModalCancel();
  }

  /**
   * Maneja el cierre interno del modal informativo y redirige si es necesario.
   */
  innerHadle() {
    if (!this.state.openModalInformativo) {
      this.setState({
        afiliados: {},
        especialidades: {},
        afiliateSelected: '',
        specialitySelected: '',
        userTypeIdentify: '',
        enableDropDown: false,
        responseContent: false,
        medicalAvailable: '',
        doctorSelected: '',
        statusRequest: '',
      });
      setTimeout(() => {
        //this.getListAffiliates();
        window.location.href = _spPageContextInfo.siteAbsoluteUrl + parseText('sharedResources.UrlRedirect.UrlMedical');
      }, 100);
    } else {
      this.setState({ openModalInformativo: false });
    }
  }

  /**
   * Envía evento de analytics cuando el usuario ya tiene cita existente.
   */
  isExistentAppointmentEvent(buttonOptionValue) {
    const userInfo = compTools.obtenerInformacionUsuario();
    AnalyticsService.trackExistentAppointmentEvent(userInfo, buttonOptionValue);
  }

  /**
   * Redirige al usuario a la próxima cita médica.
   */
  redirectToNextAppoiment() {
    this.isExistentAppointmentEvent('Próxima Cita');
    this.redirectToPrincipalUrl();
  }

  /**
   * Maneja la confirmación del modal y redirige según el estado de la cita.
   */
  handleModalConfirm() {
    this.state.sinCitas ? this.redirectToNextAppoiment() : this.innerHadle();
  }

  /**
   * Maneja la cancelación del modal y redirige o actualiza el estado según corresponda.
   */
  handleModalCancel() {
    this.isExistentAppointmentEvent('Cerrar');
    this.state.linkBack
      ? (window.location.href = _spPageContextInfo.siteAbsoluteUrl + parseText('Form.ModalMessage.LinkNoPerfil'))
      : this.setState({ error: false, sinCitas: false, sedesSeted: true });
  }

  /**
   * Redirige al usuario a la URL principal de citas médicas.
   */
  redirectToPrincipalUrl() {
    window.location.href = _spPageContextInfo.siteAbsoluteUrl + parseText('sharedResources.UrlRedirect.UrlMedical');
  }

  /**
   * Retorna el texto adecuado para los botones del modal según el estado.
   * Delega en la función utilitaria getModalButtonText.
   */
  textReturn(e, error, sincita) {
    return getModalButtonText(error, sincita);
  }

  /**
   * Calcula la cantidad de días entre dos fechas.
   * Delega en la función utilitaria getDaysBetweenDates del módulo de dateUtils.
   */
  getDaysBetweenDates(date1, date2) {
    return getDaysBetweenDates(date1, date2);
  }

  /**
   * Envía evento de analytics para acciones de incumplimiento pedagógico.
   */
  sendG4AnalyticsEvent(buttonName) {
    const userInfo = compTools.obtenerInformacionUsuario();
    AnalyticsService.trackPedagogicNonComplianceAction(userInfo, buttonName);
  }

  /**
   * Maneja la acción de levantar incumplimiento y redirige si corresponde.
   */
  handleRedirectLiftNonCompliance() {
    this.sendG4AnalyticsEvent('Levantar');
    if (this.state.urltoRedirect !== '') window.location.href = this.state.urltoRedirect;
  }

  /**
   * Maneja la acción de cancelar en el modal de incumplimientos y redirige.
   */
  handleRedirectCancelAction() {
    this.sendG4AnalyticsEvent('Cerrar');
    try {
      document.getElementById('searchAppointment').disabled = true;
    } catch (error) {
      console.log('searchAppointment not found', { error });
    }
    this.refs.redirectModalIncumplimientos.handleClose();
    this.redirectToPrincipalUrl();
  }

  /**
   * Activa y muestra el modal compuesto con múltiples botones para incumplimientos.
   */
  activeCompositeModal(title, message, firstButtonTxt, secndBtnTxt, thirdButtonTxt, redirectUrl) {
    this.setState({
      compositeModalTitle: title,
      compositeModalMessage: message,
      firstButtonText: firstButtonTxt,
      secondButtonText: secndBtnTxt,
      thirdButtonText: thirdButtonTxt,
      mensaje: message,
      urltoRedirect: redirectUrl,
    });
    this.refs.activeModalIncumplimientos.handleShow();
  }

  /**
   * Acción del primer botón del modal compuesto: redirige a levantar incumplimiento.
   */
  firstButtonAction() {
    window.location.href = _spPageContextInfo.siteAbsoluteUrl + parseText('Form.General.LiftNonComplianceURL');
  }

  /**
   * Acción del segundo botón del modal compuesto: registra cancelación y redirige al inicio.
   * El modal ya se cierra internamente desde ModalGeneralComposted antes de llamar esta acción.
   */
  secondButtonAction() {
    this.sendG4AnalyticsEvent('Cerrar');
  }

  /**
   * Acción del tercer botón del modal compuesto: redirige a ver sedes.
   */
  thirdButtonAction() {
    //Cerrar el modal!
    // Watch Appointments Locations = Ver Sedes
    window.location.href =
      _spPageContextInfo.siteAbsoluteUrl + parseText('Form.ModalMessage.AppointmentLocationsDefaultUrl');
  }

  /**
   * Renderiza saltos de línea en la descripción de la especialidad.
   */
  lineBreak(params) {
    return params.Descripcion !== undefined ? (
      params.Descripcion.includes('</br>') ? (
        params.Descripcion.split('</br>').map((item, index) => {
          return <h4>{item}</h4>;
        })
      ) : (
        <h4>{params.Descripcion}</h4>
      )
    ) : (
      <h4>{params.Descripcion}</h4>
    );
  }

  /**
   * Valida y actualiza la especialidad seleccionada según el programa del usuario.
   */
  validateInfoSpecialities(event) {
    const programs = ['CB', 'CE', 'CG', 'CM', 'EA', 'EC', 'ET', 'EU', 'PA', 'PD', 'CL', 'ML'];
    const current = this.state.userAppointmentAccess.Program;
    if (programs.includes(current)) {
      this.setState({
        specialityValueSelected: event.value,
      });
    }
  }

  /**
   * Formatea la descripción de la especialidad para mostrar como HTML.
   */
  textFormatted(params) {
    return { __html: params.Descripcion };
  }

  /**
   * Preprocesa la selección de especialidad y consulta el servicio de control de CUPS.
   */
  async getCupsControl(eventData) {
    let selectedValue = '';

    if (eventData && eventData.specialtyValue !== undefined) {
      selectedValue = eventData.specialtyValue.toString();
    } else if (eventData && eventData.target && eventData.target.value !== undefined) {
      selectedValue = eventData.target.value;
    } else if (eventData && eventData.value !== undefined) {
      selectedValue = eventData.value.toString();
    } else {
      console.error('No se pudo obtener el objeto del select', eventData);
      return eventData;
    }
    this.validateInfoSpecialities({ value: selectedValue });
    try {
      const data = await AppointmentServices.getCupsControl(
        this.state.afiliateSelected,
        this.state.userTypeId,
        selectedValue,
      );
      const { GetCupsFirstControlResult: { ResponseCode = null, Result = null } = null } = data;
      if (
        ResponseCode === 450 ||
        ResponseCode === 500 ||
        ResponseCode === 401 ||
        ResponseCode === 430 ||
        ResponseCode === 404 ||
        ResponseCode === null
      ) {
        throw new Error('Error from Client Service');
      }
      if (ResponseCode === 200 && Result?.CodigoCups !== null && Result?.CodigoCups !== undefined) {
        const codigoCups = Result.CodigoCups.toString();
        return { ...eventData, specialtyValue: codigoCups };
      }
    } catch (error) {
      console.log('error', error);
    }

    return { ...eventData, specialtyValue: selectedValue };
  }

  /**
   * Renderiza el componente principal de agendamiento de citas médicas.
   */
  render() {
    return (
      <div>
        {this.state.isAuthenticatedBoolean === true ? (
          <div className="row" id="ingresarAsignarCitaMedica">
            {this.state.popUpModal === true && this.state.popUpContent !== undefined ? (
              <ModalGeneral
                MessageTitle={this.state.popUpContent.Title}
                msg={<div dangerouslySetInnerHTML={this.textFormatted(this.state.popUpContent)} />}
                Icono={this.state.iconoModal}
                NoX={this.state.noX}
                NoAceptar={this.state.noAceptar}
                NoCancelar={this.state.noCancelar}
                colorIco={this.state.colorIco}
                AltButtonText={'Aceptar'}
                showInitial={true}
                noShowMainButton={true}
                AltButtonAction={() =>
                  this.setState({
                    popUpModal: false,
                    popUpUbicacion: true,
                    popUpApointment: true,
                  })
                }
              />
            ) : null}

            <ModalGeneral
              MessageTitle={this.state.titleModal}
              msg={this.state.messageModal}
              Icono={this.state.iconoModal}
              NoX={this.state.noX}
              NoAceptar={this.state.noAceptar}
              NoCancelar={this.state.noCancelar}
              colorIco={this.state.colorIco}
              AltButtonText={this.state.sinCitas ? 'Próxima Cita' : 'Cerrar'}
              MainButtonText={this.textReturn(this, this.state.error, this.state.sinCitas)}
              ref="activeModal"
              MainButtonAction={this.handleModalCancel}
              AltButtonAction={this.handleModalConfirm}
            />
            <ModalGeneral
              MessageTitle={this.state.titleModal}
              msg={this.state.messageModal}
              Icono={this.state.iconoModal}
              NoX={this.state.noX}
              NoAceptar={this.state.noAceptar}
              NoCancelar={this.state.noCancelar}
              colorIco={this.state.colorIco}
              AltButtonText={this.state.redirectModalAltButtonText}
              MainButtonText={this.state.redirectModalMainButtonText}
              ref="redirectModalIncumplimientos"
              MainButtonAction={this.handleRedirectLiftNonCompliance}
              AltButtonAction={this.handleRedirectCancelAction}
            />
            <ModalGeneralComposted
              MessageTitle={this.state.compositeModalTitle}
              msg={this.state.compositeModalMessage}
              TextBtnUno={this.state.firstButtonText}
              TextBtnDos={this.state.secondButtonText}
              TextBtnTres={this.state.thirdButtonText}
              BtnUnoAction={this.firstButtonAction}
              BtnDosAction={this.secondButtonAction}
              BtnTresAction={this.thirdButtonAction}
              ref="activeModalIncumplimientos"
            />

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 headerBox" id="headerCitasMedicas">
              <div>
                <h2>{parseText('Form.Header.Title')}</h2>
              </div>
              <hr />
            </div>
            <div className="principal">
              <div className="loadingWraper">
                <div className="compensarLoading">
                  <span>cargando... </span>
                </div>
              </div>
              <AffiliateAndSpecialtySelector
                UserAfiliate={this.state.afiliados}
                EspecialidadesActive={this.state.especialidades}
                OnChangeSpecialities={this.processConsultaRed.bind(this)}
                EnabledDropdown={this.state.enableDropDown}
                IsPromotionValidation={this.state.isPromotionAndPrevention}
                ValidationDataPromotion={this.state.validationDataPromotion}
                OpenModalInformative={this.openModalInformative.bind(this)}
                AddPersonalDoctor={this.state.isConditional}
                NamePlaceholderUser={this.state.namePlaceholderUser}
                NoPlaceholderUser={this.state.noPlacerholderUser}
                NamePlaceholderSpec={this.state.namePlaceholderSpec}
                NoPlaceholderSpec={this.state.noPlacerholderSpec}
                OnChangeAfiliate={this.getSpecialities.bind(this)}
                NoneValidation={this.state.nullResponseSpec}
                IconPanel={this.state.iconoNotFound}
                specialityValueSelected={this.state.specialityValueSelected}
              />
              {this.state.responseContent === true ? this.renderComponentByUserProfile() : null}
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 separatorContent">
                <hr />
              </div>
              <BackAndSearchAppointmentActions
                SearchAppoinmentUser={this.searchAppointmentByUser.bind(this)}
                EnabledButtonComplete={this.state.enableButtonComplete}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
